/**
 * @file guid.ts
 * @description Типы для работы с GUID идентификаторами в Task Manager
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-10
 * @updated 2025-09-10
 * @dependencies []
 * @related-files []
 */

/**
 * Тип для GUID строки
 * Формат: 00000000-0000-0000-0000-000000000000
 */
export type TGuid = string;

/**
 * Константы для работы с GUID
 */
export const GUID_CONSTANTS = {
    /** Пустой GUID */
    EMPTY: '00000000-0000-0000-0000-000000000000',
    /** Регулярное выражение для валидации GUID */
    REGEX: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
} as const;

/**
 * Утилиты для работы с GUID
 */
export const GuidUtils = {
    /**
     * Проверяет, является ли строка валидным GUID
     * @param value Проверяемая строка
     * @returns true если строка является валидным GUID
     */
    isValid(value: string): value is TGuid {
        return GUID_CONSTANTS.REGEX.test(value);
    },

    /**
     * Проверяет, является ли GUID пустым
     * @param guid GUID для проверки
     * @returns true если GUID пустой
     */
    isEmpty(guid: TGuid): boolean {
        return guid === GUID_CONSTANTS.EMPTY;
    },

    /**
     * Возвращает пустой GUID
     * @returns Пустой GUID
     */
    empty(): TGuid {
        return GUID_CONSTANTS.EMPTY;
    }
};